import React from 'react';
import { Dropdown, Button, Icon, Popup } from 'semantic-ui-react';
import { useNoteContext } from '../context/NoteContext';

export const AnalysisSelector: React.FC = () => {
  const {
    analyses,
    activeAnalysisId,
    switchAnalysis,
    createNewAnalysis,
    deleteAnalysis,
    duplicateAnalysis,
    getAnalysisDisplayName,
  } = useNoteContext();

  const options = analyses.map((analysis) => ({
    key: analysis.id,
    value: analysis.id,
    text: getAnalysisDisplayName(analysis.id),
    description: new Date(analysis.updatedAt).toLocaleDateString(),
  }));

  const handleChange = (_: React.SyntheticEvent, data: { value?: string | number | boolean | (string | number | boolean)[] }) => {
    if (typeof data.value === 'string') {
      switchAnalysis(data.value);
    }
  };

  const handleNew = () => {
    createNewAnalysis();
  };

  const handleDuplicate = () => {
    if (activeAnalysisId) {
      duplicateAnalysis(activeAnalysisId);
    }
  };

  const handleDelete = () => {
    if (activeAnalysisId && analyses.length > 1) {
      deleteAnalysis(activeAnalysisId);
    }
  };

  return (
    <div className="analysis-selector">
      <Dropdown
        selection
        options={options}
        value={activeAnalysisId || ''}
        onChange={handleChange}
        placeholder="Select Analysis"
        className="analysis-dropdown"
      />

      <Button.Group size="small">
        <Popup
          content="New Analysis"
          trigger={
            <Button icon onClick={handleNew}>
              <Icon name="plus" />
            </Button>
          }
        />
        <Popup
          content="Duplicate Current"
          trigger={
            <Button icon onClick={handleDuplicate} disabled={!activeAnalysisId}>
              <Icon name="copy" />
            </Button>
          }
        />
        <Popup
          content="Delete Current"
          trigger={
            <Button
              icon
              onClick={handleDelete}
              disabled={!activeAnalysisId || analyses.length <= 1}
            >
              <Icon name="trash" />
            </Button>
          }
        />
      </Button.Group>
    </div>
  );
};
